module.exports = __webpack_public_path__ + "img/sem-empty.d0a876df.png";